import axios from "axios";
import { isTest } from '../utils/isProd';
axios.defaults.timeout = 5000;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

axios.interceptors.response.use(res => {
  if (res.status === 200) {
    return Promise.resolve(res);
  } else {
    return Promise.reject(res);
  }
});

const cis = axios.create({
  baseURL: isTest ? 'https://d1.m.sohu.com/cisapi' : 'https://cis.sohu.com'
});

export const cisPost = (url, params) => {
  return new Promise((resolve, reject) => {
    cis
      .post(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
};


// WEBPACK FOOTER //
// ./src/cisService/index.js